<template>
  <div>
    cpanel will be here
  </div>
</template>

<script>
export default {
  name: 'CpanelPage'
}
</script>
